import { mapState } from 'vuex'

export default {
  components: {
    HeaderBlock: () => import('~/components/commom/header/index'),
    ButtonBlock: () => import('~/components/commom/button-block/index'),
    homeInsuranceHouseForm: () =>
      import('~/components/layouts/home-insurance-house-form/index'),
    homeInsurancePersonalForm: () =>
      import('~/components/layouts/home-insurance-personal-form/index')
  },
  async fetch({ store }) {
    if (store.state.team.members.length === 0) {
      await store.dispatch('team/getTeam')
    }
  },
  data() {
    return {
      activeStep: 0,
      houseData: {},
      personalData: {},
      isSending: false
    }
  },
  computed: {
    ...mapState(['auth']),
    teamMember() {
      return this.$store.state.team.members[0]
    },
    simulationData() {
      const today = new Date()
      const formattedDate = today.toISOString().split('T')[0]

      return {
        insured_name:
          this.personalData.firstName + ' ' + this.personalData.lastName,
        insured_email: this.personalData.email,
        insured_dob: this.personalData.insuredDob,
        insured_phone: String(this.personalData.phone),
        zip_code: this.houseData.postalCode,
        tax_number: this.personalData.nif,
        construction_year: String(this.houseData.constructionYear),
        home_capital: this.houseData.reconstructionValue,
        content_capital: this.houseData.interiorCapital,
        typology: this.houseData.typology,
        start_date: formattedDate,
        building_type: this.houseData.type,
        housing_purpose: this.houseData.housePurpose,
        insurance_type: this.houseData.insuranceType,
        user_language: 'PT', // this.userLanguage
        gross_private_area: this.houseData.grossPrivateArea,
        gross_dependent_area: this.houseData.grossDependentArea,
        number_of_bathrooms: this.houseData.numberOfBathrooms
      }
    }
  },
  methods: {
    isStepActive(index) {
      return index === this.activeStep
    },
    goToNextStep() {
      this.$gtm.pushEvent({
        event:
          this.activeStep === 0
            ? 'home_simulation_start'
            : 'home_step1_completed'
      })

      this.activeStep++
      window.scrollTo(0, 0)
    },
    submitForm() {
      if (this.isSending) {
        return
      }

      this.isSending = true

      this.sendToServer()
        .then((response) => {
          this.isSending = false

          this.$gtm.pushEvent({
            event: 'home_simulation'
          })
          return this.handleSucessSubmission(response.data)
        })
        .catch((_error) => {
          this.isSending = false
        })
    },
    sendToServer() {
      return this.$axios.post(
        '/homeinsurance/createquote',
        this.simulationData,
        {
          headers: {
            'Content-type': 'application/json; charset=utf-8'
          },
          withCredentials: true
        }
      )
    },

    handleSucessSubmission(response) {
      this.saveSimulationData(this.simulationData)
      this.saveSimulationOnStorage(response.uuid)
      this.$router.push(
        this.localePath({
          name: 'simulacao-seguro-multirriscos-resultados-id',
          params: {
            id: response.uuid
          }
        })
      )
    },
    saveSimulationData(simulationData) {
      return this.$store.commit('localStorage/SAVE_SIMULATION_DATA', {
        simulationData
      })
    },
    saveSimulationOnStorage(id, hash) {
      if (this.auth.isLoggedIn) {
        return
      }
      return this.$store.commit('localStorage/ADD_ANONYMOUS_HOME_SIMULATION', {
        id
      })
    }
  }
}
